// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","682":"component---src-pages-about-js","744":"component---src-templates-blog-js","774":"framework","851":"component---src-templates-post-js","883":"component---src-pages-404-js","942":"component---src-templates-tags-js"}[chunkId] || chunkId) + ".js";
};